import {hideDrawerInit, openDrawer} from '../../js/partials/drawer';
import {paginationInit} from '../../js/partials/pagination';
import {sortingInit} from '../../js/partials/sorting-bar';
import {scrollIntoView} from '../../js/utils/scrollIntoView';
import {createUnencodedQueryString} from '../../js/utils/createUnencodedQueryString';
import {createNewUrl} from '../../js/utils/createNewUrl';
import {initProductImageChange} from '../../js/utils/changeProductImage';

const OFFER_FILTER_KEY = document.querySelector('[data-js-selector="offer-filter-key"]')?.value;

const onLoad = () => {
    const filterForm = document.getElementById('filter-form');

    if (!filterForm) {
        return;
    }

    openFiltersInit(filterForm);
    showFilterContent();
    toggleParameters();
    onPriceGroupSelect();
    // loadPriceSlider();
    const customSliders = document.getElementsByClassName('custom-slider__container');
    customSliders.length > 0 ? Array.from(customSliders).forEach((slider) => loadCustomSlider(slider)) : null;
    const filterValues = document.querySelectorAll('[data-js-selector="filter-value"]');
    const submitButton = document.querySelector('[data-js-selector="filter-submit-button"]');
    const availabilityButtons = document.querySelectorAll('[data-js-selector*="filter-value-availability"]');
    const resetFilter = document.querySelectorAll('[data-js-selector="filter-reset"]');
    const removeFilterParameters = document.querySelectorAll('[data-js-selector="filter-remove-parameter"]');

    filterForm.addEventListener('submit', (e) => {
        e.preventDefault();
    });

    if (filterValues.length > 0) {
        filterValues.forEach((submitBtn) => {
            submitBtn.addEventListener('click', (e) => submitForm(e));
        });
    }
    submitButton.addEventListener('click', (e) => submitForm(e, true, true));
    availabilityButtons.forEach((availabilityButton) => {
        availabilityButton.addEventListener('click', (event) => {
            document.documentElement.style.overflow = 'auto';
            submitForm(
                event,
                !availabilityButton.getAttribute('data-js-selector').includes('filter-value-availability-module'),
            );
        });
    });
    if (resetFilter.length > 0) {
        resetFilter.forEach((resetFilterBtn) => {
            document.documentElement.style.overflow = 'auto';
            resetFilterBtn.addEventListener('click', (e) => resetFilterHandler(e));
        });
    }

    if (removeFilterParameters.length > 0) {
        removeFilterParameters.forEach((removeFilterParameterBtn) => {
            removeFilterParameterBtn.addEventListener('click', (e) => removeFilterParameter(e));
        });
    }
};

const submitForm = (e, instantSubmit = false, isSubmitButton = false) => {
    const isMobile = window.getComputedStyle(
        document.querySelector('[data-js-selector="filter-content"]'),
    ).position == 'fixed';
    if (isMobile && !instantSubmit && !isSubmitButton) {
        return false;
    }
    const searchParams = new URLSearchParams(window.location.search);
    const searchQuery = searchParams.get('q');
    const form = document.getElementById('filter-form');
    const values = {};
    const deconstructPriceGroup = function(id) {
        return id.split('-');
    };

    const checkboxesAndRadios = form.querySelectorAll('input[type="checkbox"][name], input[type="radio"][name]');
    checkboxesAndRadios.forEach(function(input) {
        if (input.checked && !input.classList.contains('js-price-group-input-own-selection')) {
            if (input.classList.contains('js-price-group-input')) {
                const [from, to] = deconstructPriceGroup(input.id);
                values['filter.v.price.gte'] = from;
                values['filter.v.price.lte'] = to;
            } else if (
                input.type === 'checkbox' &&
                !input.getAttribute('data-js-selector').includes('filter-value-availability')
            ) {
                values[input.name] = values[input.name] || [];
                values[input.name].push(input.value);
            } else if (
                input.type === 'checkbox' &&
                input.getAttribute('data-js-selector').includes('filter-value-availability')
            ) {
                if (
                    isSubmitButton &&
                    input.getAttribute('data-js-selector').includes('filter-value-availability-module')
                ) {
                    values[input.name] = values[input.name] || [];
                    values[input.name].push(input.value);
                } else if (
                    !isSubmitButton &&
                    !input.getAttribute('data-js-selector').includes('filter-value-availability-module')
                ) {
                    values[input.name] = values[input.name] || [];
                    values[input.name].push(input.value);
                }
            } else if (input.type === 'radio') {
                values[input.name] = input.value;
            }
        }
    });

    const selects = form.querySelectorAll('select[name]');
    selects.forEach(function(select) {
        if (select.value) {
            values[select.name] = select.value;
        }
    });

    const sliders = form.querySelectorAll('input[type="number"][name]');
    sliders.forEach(function(slider) {
        if (
            (slider.name === 'filter.v.price.gte' || slider.name === 'filter.v.price.lte') &&
            slider.classList.contains('is-open')
        ) {
            values[slider.name] = slider.value;
        } else if (slider.name !== 'filter.v.price.gte' && slider.name !== 'filter.v.price.lte') {
            values[slider.name] = slider.value;
        }
    });

    const customSliders = form.querySelectorAll('.custom-slider__container');
    customSliders.forEach(function(slider) {
        const param = slider.getAttribute('param');
        if (searchParams.get(param)) {
            values[param] = searchParams.get(param);
        }
    });

    if (Object.keys(values).length > 0) {
        for (const [key, value] of Object.entries(values)) {
            const paramLength = searchParams.get(key) ? searchParams.get(key).split(',').length : 0;
            if (!searchParams.get(key) || paramLength !== value.length || searchParams.get(key) !== value) {
                searchParams.set(key, value);
            }
            if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
                searchParams.set(key, value);
            }
        }
    }

    for (const key of searchParams.keys()) {
        if (!values.hasOwnProperty(key) && key !== 'sort_by') {
            searchParams.delete(key);
        }
    }

    searchQuery ? searchParams.set('q', searchQuery) : searchParams.delete('q');
    updateUrlAndContent(searchParams);
};

const resetFilterHandler = (event) => {
    event.preventDefault();
    const searchParams = new URLSearchParams(window.location.search);
    const searchQuery = searchParams.get('q');
    const newSearchParams = new URLSearchParams();

    if (searchQuery !== null) {
        newSearchParams.set('q', searchQuery);
    }

    updateUrlAndContent(newSearchParams);
};

const removeFilterParameter = (event) => {
    event.preventDefault();
    const urlValue = event.currentTarget.getAttribute('href');
    updateUrlAndContent(null, urlValue);
};

const loadCustomSlider = (slider) => {
    const handle = slider.getAttribute('handle');
    const param = slider.getAttribute('param');
    const fromSlider = document.querySelector(`#${handle}-fromCustomSlider`);
    const toSlider = document.querySelector(`#${handle}-toCustomSlider`);
    const fromInput = document.querySelector(`#${handle}-fromCustomInput`);
    const toInput = document.querySelector(`#${handle}-toCustomInput`);

    const {from, to, values} = setCustomRangeValues(handle, fromSlider, toSlider, fromInput, toInput);
    loadCustomSliderValues(param, fromSlider, toSlider, fromInput, toInput, values);

    fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput, values);
    toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput, values);
    fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider, values);
    toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider, values);
    document.querySelector(`#${handle}-submit-custom-range`)
        .onclick = (e) => submitCustomSlider(param, e.target, fromInput, toInput, values);
    // loadCustomRangeValues(fromSlider, toSlider, fromInput, toInput);
    fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
    setToggleAccessible(toSlider);
};

const loadCustomSliderValues = (paramName, fromSlider, toSlider, fromInput, toInput) => {
    const searchParams = new URLSearchParams(window.location.search);
    const selectedValues = searchParams.get(paramName) ? searchParams.get(paramName).split(',') : null;
    if (!selectedValues) return;
    const values = selectedValues.map((value) => Number(value));
    const from = Math.min(...values);
    const to = Math.max(...values);
    if (from && to) {
        fromSlider.value = from;
        toSlider.value = to;
        fromInput.value = from;
        toInput.value = to;
    }
};

const submitCustomSlider = (paramName, target, fromInput, toInput, values) => {
    const [from, to] = getParsed(fromInput, toInput);
    const selectedValues = values.filter((value) => value >= from && value <= to).join(',');
    let queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    urlParams.delete(paramName);
    queryString = createUnencodedQueryString(urlParams);

    const separator = queryString.length > 0 ? '&' : '?';
    queryString += separator + paramName + '=' + selectedValues;

    window.location.search = queryString;
};

const setCustomRangeValues = (handle, fromSlider, toSlider, fromInput, toInput) => {
    const allSliderInputs = document.querySelectorAll(`.${handle}-custom-slider__value`);
    const values = Array.from(allSliderInputs).map((li) => Number(li.getAttribute('value')));
    const from = Math.min(...values);
    const to = Math.max(...values);
    if (from && to) {
        fromSlider.value = from;
        toSlider.value = to;

        fromSlider.min = from;
        fromSlider.max = to;
        toSlider.min = from;
        toSlider.max = to;

        fromInput.value = from;
        toInput.value = to;

        fromInput.min = from;
        fromInput.max = to;
        toInput.min = from;
        toInput.max = to;

        return {from, to, values};
    }
};

const loadPriceSlider = () => {
    const [fromSlider, toSlider, fromInput, toInput] = loadSlider(
        'fromPriceSlider', 'toPriceSlider', 'fromPriceInput', 'toPriceInput',
    );
    loadPriceRangeValues(fromSlider, toSlider, fromInput, toInput);
    fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
    setToggleAccessible(toSlider);
};

const loadSlider = (fromSliderSelector, toSliderSelector, fromInputSelector, toInputSelector) => {
    const fromSlider = document.querySelector(`#${fromSliderSelector}`);
    const toSlider = document.querySelector(`#${toSliderSelector}`);
    const fromInput = document.querySelector(`#${fromInputSelector}`);
    const toInput = document.querySelector(`#${toInputSelector}`);

    fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
    toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
    fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
    toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

    return [fromSlider, toSlider, fromInput, toInput];
};

const onPriceGroupSelect = () => {
    const radioBtns = document.querySelectorAll('.js-price-group-input');
    const ownSelectionButton = document.querySelector('.js-price-group-input-own-selection');
    const priceRangeElement = document.querySelector('.js-price-group-price-range');
    const priceRangeInputElements = document.querySelectorAll('.js-price-group-price-range-input');

    radioBtns.forEach((button) => {
        button.addEventListener('click', () => {
            if (priceRangeElement.classList.contains('is-open')) {
                priceRangeElement.classList.remove('is-open');
                priceRangeInputElements.forEach((e) => {
                    e.classList.remove('is-open');
                });
                ownSelectionButton.checked = false;
            }
        });
    });

    if (!ownSelectionButton) {
        return;
    }

    ownSelectionButton.addEventListener('click', () => {
        if (!priceRangeElement.classList.contains('is-open')) {
            radioBtns.forEach((radioBtn) => {
                if (radioBtn.checked) {
                    radioBtn.checked = false;
                }
            });
            priceRangeElement.classList.add('is-open');
            priceRangeInputElements.forEach((e) => {
                e.classList.add('is-open');
            });
        }
    });
};

const findClosestValue = (currentValue, allowedValues) => {
    let closest = allowedValues[0];
    let minDiff = Math.abs(currentValue - closest);

    for (let i = 1; i < allowedValues.length; i++) {
        const diff = Math.abs(currentValue - allowedValues[i]);
        if (diff < minDiff) {
            minDiff = diff;
            closest = allowedValues[i];
        }
    }

    return closest;
};

const loadPriceRangeValues = (fromSlider, toSlider, fromInput, toInput) => {
    const searchParams = new URLSearchParams(window.location.search);
    const from = searchParams.get('filter.v.price.gte');
    const to = searchParams.get('filter.v.price.lte');
    if (from && to) {
        fromSlider.value = from;
        toSlider.value = to;
        fromInput.value = from;
        toInput.value = to;
    }
};

const controlFromInput = (fromSlider, fromInput, toInput, controlSlider, values) => {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
    if (from > to) {
        values ? fromSlider.value = findClosestValue(to, values) : fromSlider.value = to;
        values ? fromInput.value = findClosestValue(to, values) : fromInput.value = to;
    } else {
        values ? fromSlider.value = findClosestValue(from, values) : fromSlider.value = from;
    }
};

const controlToInput = (toSlider, fromInput, toInput, controlSlider, values) => {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
    setToggleAccessible(toInput);
    if (from <= to) {
        values ? toSlider.value = findClosestValue(to, values) : toSlider.value = to;
        values ? toInput.value = findClosestValue(to, values) : toInput.value = to;
    } else {
        values ? toInput.value = findClosestValue(from, values) : toInput.value = from;
    }
};

const controlFromSlider = (fromSlider, toSlider, fromInput, values) => {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
    if (from > to) {
        values ? fromSlider.value = findClosestValue(to, values) : fromSlider.value = to;
        values ? fromInput.value = findClosestValue(to, values) : fromInput.value = to;
    } else {
        values ? fromInput.value = findClosestValue(from, values) : fromInput.value = from;
    }
};

const controlToSlider = (fromSlider, toSlider, toInput, values) => {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
    setToggleAccessible(toSlider);
    if (from <= to) {
        values ? toSlider.value = findClosestValue(to, values) : toSlider.value = to;
        values ? toInput.value = findClosestValue(to, values) : toInput.value = to;
    } else {
        values ? toInput.value = findClosestValue(from, values) : toInput.value = from;
        values ? toSlider.value = findClosestValue(from, values) : toSlider.value = from;
    }
};

const getParsed = (currentFrom, currentTo) => {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
};

const fillSlider = (from, to, sliderColor, rangeColor, controlSlider) => {
    const rangeDistance = to.max - to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
};

const setToggleAccessible = (currentTarget) => {
    const toSlider = document.querySelector('#toPriceSlider');
    if (Number(currentTarget.value) <= 0) {
        toSlider.style.zIndex = 2;
    } else {
        toSlider.style.zIndex = 0;
    }
};

const toggleParameters = () => {
    const buttonElement = '[data-js-selector="filter-show-more-parameters-button"]';
    const containerElement = '[data-js-selector="filter-show-more-parameters-container"]';
    const contentElement = '[data-js-selector="filter-show-more-parameters-list"]';

    document.querySelectorAll(buttonElement).forEach((button) => {
        button.addEventListener('click', (e) => {
            const container = e.target.closest(containerElement);
            const contentList = container.querySelector(contentElement);

            if (button.classList.contains('is-open')) {
                button.classList.remove('is-open');
                contentList.querySelectorAll('li').forEach((li, index) => {
                    if (index > 4) {
                        li.classList.add('is-hidden');
                    }
                });
            } else {
                button.classList.add('is-open');
                contentList.querySelectorAll('li').forEach((li) => {
                    if (li.classList.contains('is-hidden')) {
                        li.classList.remove('is-hidden');
                    }
                });
            }
        });
    });
};

const openFiltersInit = (selector) => {
    const filterItems = selector.querySelectorAll('[data-js-selector="filter-content-item"]');
    const openFiltersCount = selector.getAttribute('data-open-filters-count');

    for (let i = 0; i < Math.min(filterItems.length, openFiltersCount); i++) {
        filterItems[i].classList.add('is-open');
        filterItems[i].querySelector('[data-js-selector="filter-content-item-title"]').classList.add('is-open');
        filterItems[i].querySelector('[data-js-selector="filter-content-item-content-wrapper"]')
            .classList.add('is-open');
    }
};

const showFilterContent = () => {
    const buttonsElement = '[data-js-selector="filter-show-content-button"]';
    const drawerElement = document.querySelector('[data-drawer-selector="drawer"]');

    document.querySelectorAll(buttonsElement).forEach((button) => {
        button.addEventListener('click', () => {
            openDrawer(drawerElement);
        });
    });
};

const fetchAndUpdateContent = (pageUrl) => {
    const collectionMainElement = document.querySelector('[data-js-selector="collection-main"]');
    collectionMainElement.setAttribute('data-loading', true);
    fetch(pageUrl)
        .then((response) => {
            if (!response.ok) {
                collectionMainElement.setAttribute('data-loading', false);
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then((htmlString) => {
            const parser = new DOMParser();
            const html = parser.parseFromString(htmlString, 'text/html');

            const oldSections = document.querySelectorAll('.refreshWithFilter');
            const newSections = html.querySelectorAll('.refreshWithFilter');
            oldSections.forEach((oldSection, index) => {
                const newSection = newSections[index];

                if (newSection.classList.contains('filter')) {
                    openFiltersInit(newSection);
                }

                oldSection.innerHTML = newSection.innerHTML;
            });
            onLoad();
            window.toggleContentInit();
            paginationInit();
            sortingInit();
            collectionMainElement.setAttribute('data-loading', false);
            scrollIntoView('[data-js-selector="collection-main-products"]');
            document.documentElement.style.overflow = 'visible';
            hideDrawerInit();
            window.hideOrShowBestsellingLoader();
            initProductImageChange();
        })
        .catch((error) => {
            console.error('Fetch error:', error);
            collectionMainElement.setAttribute('data-loading', false);
        });
};

const updateUrlAndContent = (searchParams, url) => {
    const template = document.getElementById('filter-form');
    const templateSuffix = template.getAttribute('data-template');
    if (templateSuffix === 'offer') {
        searchParams.set(OFFER_FILTER_KEY, '1');
    } 
    const newUrl = url ?? createNewUrl(searchParams);
    window.history.pushState({path: newUrl}, '', newUrl);
    fetchAndUpdateContent(newUrl);
};

onLoad();
